module.exports = __webpack_public_path__ + "img/footer-sisley-logo.8be96061.svg";